import React from "react";
import { Grid, Select,FormControl } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import { useTranslation } from 'react-i18next';

//class Room extends React.Component;

export default function Room(props) {

    const { removeRoom, modifyAdults, modifyChildren, updateChildAge } = props;
    const { t } = useTranslation();

    return (
        <>
            <Grid item xs={12} className={props.room_index>0?'room-header-with-margin':'room-header'}>
            <h4 className="room-composition-title">{t('package.modals.quantity.roomComposition', { number: props.room_index+1 })}</h4>
                <span className={props.room_index===0?' hidden room-remove-link':'room-remove-link'} onClick={(e) =>
                    removeRoom(props.room_index)}>({t('package.modals.quantity.removeRoom')})
                </span>
            </Grid>
            <Grid item xs={7} lg={9}>
                <h4 className="pax-title-bold">{t('pax.adults.title')}</h4>
                <small className="pax-age-hint">{t('package.modals.quantity.adultsAge')}</small>
            </Grid>
            <Grid item xs={5} lg={3} className="mb-3" align="center">
            <Grid container>
                <Grid item xs={5}>
                <div
                    className="plus" 
                    name="adults"
                    onClick={(e) => modifyAdults(props.room_index, 1)}
                    
                >
                    +
                </div>
                </Grid>
                <Grid item xs={2} className="caption">
                <strong>{props.data.adults.length}</strong>
                </Grid>
                <Grid item xs>
                <div className="minus" 
                    onClick={(e) => modifyAdults(props.room_index, -1)}
                >
                    -
                </div>
                </Grid>
            </Grid>
            </Grid>

            <Grid item xs={7} lg={9} className="mt-2">
                <h4 className="pax-title-bold">{t('pax.children.title')}</h4>
                <small className="pax-age-hint">{t('package.modals.quantity.childrenAge')}</small>
            </Grid>
            <Grid item xs={5} lg={3} className="mb-3 mt-2" align="center">
                <Grid container>
                    <Grid item xs={5}>
                    <span
                        className="plus" 
                        name="children"
                        onClick={(e) => modifyChildren(props.room_index, 1)}
                    >
                        +
                    </span>
                    </Grid>
                    <Grid item xs={2} className="caption">
                    <strong>{props.data.children.length}</strong>
                    </Grid>
                    <Grid item xs>
                    <span
                        className="minus" 
                        onClick={(e) => modifyChildren(props.room_index, -1)}
                    >
                        -
                    </span>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}  className={props.data.children.length===0?' hidden ':''}>
                <h4 className={props.data.children.length>1?'children-ages-title':' hidden '}>{t('package.modals.quantity.childrenAges')}</h4>
                <h4 className={props.data.children.length===1?'children-ages-title':' hidden '}>{t('package.modals.quantity.childAge')}</h4>
                <span className="children-age-selects">
                    {
                        props.data.children.map((child, index)=>
                        <FormControl variant="outlined" className="child-age-select">
                            <Select nativ value={child} onChange={(e)=>{updateChildAge(props.room_index, index, e.target.value)}}>
                                <MenuItem value={0}>0-1</MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={6}>6</MenuItem>
                                <MenuItem value={7}>7</MenuItem>
                                <MenuItem value={8}>8</MenuItem>
                                <MenuItem value={9}>9</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={11}>11</MenuItem>
                                <MenuItem value={12}>12</MenuItem>
                                <MenuItem value={13}>13</MenuItem>
                                <MenuItem value={14}>14</MenuItem>
                                <MenuItem value={15}>15</MenuItem>
                                <MenuItem value={16}>16</MenuItem>
                                <MenuItem value={17}>17</MenuItem>
                            </Select>
                        </FormControl>
                        )
                    }
                </span>
            </Grid>

{
/*
            <Grid item xs={7} lg={9}>
            <strong>{t('package.modals.quantity.infantsAgeRange')}</strong>
            </Grid>
            <Grid item xs={5} lg={3} className="mb-3">
            <Grid container>
                <Grid item xs={5}>
                <span 
                    className="plus" 
                    name="infants"
                    onClick={(e) =>
                    setState({
                        ...state,
                        infants:
                        state.infants + 1 < 10
                            ? state.infants + 1
                            : state.infants,
                    })
                    }
                >
                    +
                </span>
                </Grid>
                <Grid item xs={2} className="caption">
                <strong>{state.infants}</strong>
                </Grid>
                <Grid item xs>
                <span
                    className="minus" 
                    onClick={(e) =>
                    setState({
                        ...state,
                        infants:
                        state.infants > 0 ? state.infants - 1 : state.infants,
                    })
                    }
                >
                    -
                </span>
                </Grid>
            </Grid>
            </Grid>
*/
}

{/*
            <Grid item xs={7} lg={9}>
            <strong>{t('package.modals.quantity.seniorsAgeRange')}</strong>
            </Grid>
            <Grid item xs={5} lg={3} className="mb-2">
            <Grid container>
                <Grid item xs={5}>
                <span
                    className="plus" 
                    name="seniors"
                    onClick={(e) =>
                    setState({
                        ...state,
                        seniors: state.seniors + 1 < 10 ? state.seniors + 1 : state.seniors,
                    })
                    }
                >
                    +
                </span>
                </Grid>
                <Grid item xs={2} className="caption">
                <strong>{state.seniors}</strong>
                </Grid>
                <Grid item xs>
                <span
                    className="minus" 
                    onClick={(e) =>
                    setState({
                        ...state,
                        seniors: state.seniors > 0 ? state.seniors - 1 : state.seniors,
                    })
                    }
                >
                    -
                </span>
                </Grid>
            </Grid>
            </Grid>
*/}
    </>
    )
    
    
}

//export default Room